import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../Api/Api";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import { Loader } from "../Global/Loader";
import { Popup } from "../Global/Popup";
import Button from "@material-ui/core/Button";

import Navbar from "../Global/Navbar";
import Header from "../Global/Header";
import ItemAward from "./itemAward";

SwiperCore.use([EffectCoverflow, Pagination]);

const Award = (props) => {
  const [state, setState] = useState({
    data: null,
    loader: true,
    popupStatus: false,
    disableBtn: false,
    countPopupStatus: false,
    user_score: "",
    required_score: "",
    count: 1,
    lottoryId: null,
    error: { id: 0, message: "" },
  });
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("logined")) == null) {
      props.history.push(`/Entrance`);
    }
    updataData();
    console.log(props, "َawards props");
  }, []);

  const updataData = () => {
    setState({
      ...state,
      data: null,
      loader: true,
      popupStatus: false,
    });

    base_url
      .get("lotteries")
      .then((response) => {
        console.log(response.data);
        setState({
          ...state,
          data: response.data.lotteries,
          loader: false,
          popupStatus: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  };

  const lotteryRegister = (id, user_score, required_score) => {
    setState({
      ...state,
      lottoryId: id,
      countPopupStatus: true,
      user_score: user_score,
      required_score: required_score,
    });
  };

  const lattary = () => {
    setState({
      ...state,
      countPopupStatus: false,
      loader: true,
    });
    const Data = {
      lottery_id: state.lottoryId,
      count: state.count,
    };

    base_url
      .post("lottery_register", Data)
      .then((response) => {
        console.log(response);
        setState({
          ...state,
          loader: false,
          countPopupStatus: false,
          popupStatus: true,
        });
      })
      .catch((error) => {
        if (error.response.status === 422) {
          setState((perv) => ({
            ...perv,
            loader: false,
            error: {
              id: Data.lottery_id,
              message: error.response.data.message,
            },
          }));
        }
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
        }
      });
  };

  const countHandler = (type) => {
    let available = state.user_score / state.required_score;
    if (type === "plus") {
      if (state.count < available) {
        setState({ ...state, count: state.count + 1 });
      }
    } else if (type === "minus") {
      if (state.count > 1) {
        setState({ ...state, count: state.count - 1 });
      }
    }
    console.log(available);
  };

  return (
    <div className={`instructpg Award ${state.loader ? "" : "active"}`}>
      <Loader active={state.loader} />
      <Header />
      <Popup active={state.popupStatus} classes="popup-lotteries">
        <h4>شما با موفقیت در قرعه کشی ثبت نام کردید.</h4>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={updataData}>
            خروج
          </Button>
        </div>
      </Popup>
      <Popup
        active={state.countPopupStatus}
        classes="popup-lotteries choose-lotteri"
      >
        <h4>شرکت در قرعه کشی</h4>
        <p>
          تعداد دفعات شرکت در قرعه‌کشی را انتخاب کنید. <br /> هرچه تعداد دفعات
          شرکت در قرعه‌کشی بیشتر باش، شانس شما برای برنده شدن بیشتر خواهد بود
        </p>
        <div className="count-handler">
          <button onClick={(e) => countHandler("plus")}> + </button>
          <span>{state.count}</span>
          <button className="minus" onClick={(e) => countHandler("minus")}>
            {" "}
            -{" "}
          </button>
        </div>
        <div className="row-scors">
          <div className="scrs">
            <span>امتیاز شما : </span>
            <b>{state.user_score}</b>
          </div>
          <div className="scrs">
            <span>حداقل امتیاز : </span>
            <b>{state.required_score}</b>
          </div>
        </div>
        <div className="btns">
          <Button variant="contained" onClick={() => lattary()}>
            تایید
          </Button>
          <Button
            className="cancle"
            variant="contained"
            onClick={() => setState({ ...state, countPopupStatus: false })}
          >
            لغو
          </Button>
        </div>
      </Popup>
      <div className="body-award">
        {state.data == null ? (
          <SwiperSlide></SwiperSlide>
        ) : (
          <Swiper
            effect="coverflow"
            centeredSlides={true}
            spaceBetween={0}
            slidesPerView={1}
            grabCursor={true}
            pagination={{ clickable: true }}
          >
            {state.data.map((item) => (
              <SwiperSlide key={item.id}>
                <ItemAward
                  error={state.error}
                  key={item.id}
                  data={item}
                  lotteryRegister={lotteryRegister}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      <Navbar />
    </div>
  );
};

export default Award;
